<div>
	@if (!isMobileOrTabletView() && referrerSeries(); as referrerSeries) {
	<lib-card [title]="'Referrer overview'" [subtitle]="'Data taken from last 90 days'">
		<lib-pie-chart [showLabels]="false" [singleSeries]="referrerSeries" [legendPosition]="'right'"></lib-pie-chart>
	</lib-card>
	}
</div>

@if (referrerTable(); as referrerTable) {
<lib-card [title]="'Referrers by count'" class="push-top-md">
	<lib-table [table]="referrerTable"></lib-table>
</lib-card>
}
